import React from "react";

const AddNote = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M34 25.111 25.111 34v-8.889H34ZM32.24 2H3.76C2.782 2 2 2.782 2 3.76v28.48c0 .978.8 1.76 1.778 1.76h17.778V23.333l.017-.213a1.74 1.74 0 0 1 1.547-1.547l.213-.017H34V3.778C34 2.8 33.218 2 32.24 2Zm-6.453 11.52H19.67v6.116h-2.773V13.52h-6.116v-2.773h6.116V4.63h2.773v6.116h6.116v2.773Z"
            fill={fill}
        />
    </svg>
);

export default AddNote;
